import React, { PureComponent } from "react";
import PropTypes from "prop-types";
import { Button } from "arv-reactcomponents";

class CheckoutMyBagButton extends PureComponent {
  render() {
    const { titleKey, className, onClickFn } = this.props;
    return (
      <Button className={className} onClick={onClickFn}>
        {titleKey}
      </Button>
    );
  }
}
CheckoutMyBagButton.propTypes = {
  titleKey: PropTypes.string.required,
  className: PropTypes.string.required,
  onClickFn: PropTypes.func,
};

const getFinalComponent = component => component;

const ProjectComponent = {
  getFinalComponent,
  wrapper: CheckoutMyBagButton,
  component: CheckoutMyBagButton,
};

export default ProjectComponent;



// WEBPACK FOOTER //
// ./src/component/CheckoutMyBagButton/index.js